module.exports = __webpack_public_path__ + "img/442.69245538.png";